/* Package JSON Import will be here */
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import * as loginActions from '../../../actions/login.Action';
import AttestationComponent from './Attestation.Component';
import { Constants } from '../../../config/appConstants';
import { CheckEnterHours, EmptyAttestDetails } from './AttestationUtils';
import { ApiUrls } from '../../../services/api';
import { MessageBox } from '../../sharedComponent/messageBox';
import Api from '../../../services/api/serviceCall';
import { cloneDeep, isEqual } from 'lodash';
import * as utility from '../../../services/utility';
/* Project Import will be here */

class Attestation extends Component {
    constructor(props) {
        super(props);

        const locationState = this?.props?.location?.state ?? undefined;
        const isFromWeekTimeCard = locationState?.isFromWeekTimeCard ?? false
        let attestationDetails = { ...EmptyAttestDetails(), ...(locationState?.attestTimeCardDetails ?? {}) };
        if (isFromWeekTimeCard) {
            attestationDetails = locationState?.attestationDetails ?? EmptyAttestDetails();
        }

        this.state = {
            attestationDetails: attestationDetails,
            initialAttestationDetails: cloneDeep(attestationDetails),
            attestTimeCardDetails: locationState?.attestTimeCardDetails ?? {},
            empId: locationState?.empId ?? 0,
            timeRecords: locationState?.timeRecords ?? [],
            attestationPDF: locationState?.attestationPDF ?? "",
            isSubmittedAttestation: locationState?.isSubmittedAttestation ?? false,
            isFromWeekTimeCard: isFromWeekTimeCard,
            attestationLanguages: [
                { id: 0, text: Constants.ATTESTATION_LANGUAGE_ENGLISH, value: Constants.ATTESTATION_LANGUAGE_ENGLISH },
                { id: 1, text: Constants.ATTESTATION_LANGUAGE_SPANISH, value: Constants.ATTESTATION_LANGUAGE_SPANISH }
            ],
            supervisorOverrideReasons: [],
            isRejectedAttestation: false,
            isAttestationSaveBtnDisabled: false,
            isAttestationDeleteBtnDisabled: false,
            isShowDeleteAttestModal: false,
            isShowBackAttestationModal: false,
            isShowSwitchingAttestModal: false,
            isShowAttestationLoader: false,
            isShowAttestationErrorModal: false,
            attestErrorValidationMessage: "",
            attestationSwitchingMessage: Constants.ATTESTATION_SUPERVISOR_SWITCHING_MESSAGE,
            signatureRef: createRef(),
            popupRef: createRef(),
            isShowEditAttestationConfirmationModal: false,
            attestationEditConfirmationMessage: Constants.ATTESTATION_EDIT_CONFIRMATION_MESSAGE,
            modifiedAttestationDetail: {},
        };
    }

    componentDidMount() {
        const locationState = this?.props?.location?.state ?? undefined;
        if (!locationState) {
            this.navigateToTimeCardPage();
            return;
        }

        this.setState({ isShowAttestationLoader: true }, async () => {
            await this.getSuperVisorOverrideReasons();
            if (!this.state.isFromWeekTimeCard) {
                await this.getAttestationDetails();
            } else {
                this.setState({ isShowAttestationLoader: false });
            }
        });
    }

    componentWillUnmount() {
        this.emptyAttestationData();
    }

    async getSuperVisorOverrideReasons() {
        try {
            const url = `${ApiUrls.Routes.SPVRORERN_C}${ApiUrls.Routes.GT_SPVR_ORE_RN_LT_M}`;
            const responseData = await Api.Post(url, {}, this);
            if (!responseData.success) {
                MessageBox(responseData.message, Constants.ERROR);
                return;
            }

            if (!responseData?.data) return;

            responseData.data.sort((a, b) => {
                const nameA = a.displayText.toUpperCase();
                const nameB = b.displayText.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });
            const supervisorOverrideReasons = responseData.data.map(a => {
                return {
                    id: a.id,
                    value: a.displayText,
                    text: a.displayText
                };
            });
            this.setState({ supervisorOverrideReasons });
        } catch (error) {
            MessageBox(error, Constants.ERROR);
        }
    }

    async getAttestationDetails() {
        const { timeRecords, empId, attestTimeCardDetails } = this.state;
        const timeRecord = timeRecords.find(a => a.employeeID === empId);
        const timeCardList = timeRecord.timecardData[0];
        const { totalStHours, totalOtHours, totalDtHours } = timeRecord;
        const attestTimeCardIds = timeRecord.timecardData.map(a => a.timeRecordID);
        const attestTimeCardDetails2 = {
            stHours: utility.getFormatedTotalHours(totalStHours),
            otHours: utility.getFormatedTotalHours(totalOtHours),
            dtHours: utility.getFormatedTotalHours(totalDtHours),
            employeeName: `${timeCardList.employeeNumber} - ${timeCardList.fullName}`,
            employeeNumber: timeCardList.employeeNumber,
            startTime: timeCardList.startTime,
            endTime: timeCardList.endTime,
            lunchStartTime: timeCardList.lunchStartTime,
            lunchEndTime: timeCardList.lunchEndTime,
            createdDate: timeCardList.createdDate,
            attestTimeCardIds: attestTimeCardIds
        };
        const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.GT_ATTST_BTMCRD_ID_M}?deviceId=${this.props.device.deviceId}&timeRecordId=${attestTimeCardIds[0]}&inProgressOnly=${true}`;

        try {
            const response = await Api.Get(url, this);
            if (response.success) {
                let attestationDetails = response.data;
                if (!attestationDetails || !attestationDetails.attestationStatus) {
                    attestationDetails = EmptyAttestDetails();
                } else {
                    attestationDetails.isSignatureExist = true;
                }
                if (!attestTimeCardDetails || Object.keys(attestTimeCardDetails).length == 0) {
                    attestationDetails = { ...attestationDetails, ...attestTimeCardDetails2 };
                } else {
                    attestationDetails = { ...attestationDetails, ...attestTimeCardDetails };
                }
                utility.replaceNullWithStringInObject(attestationDetails);
                this.setState({ attestationDetails, initialAttestationDetails: cloneDeep(attestationDetails) });
            } else {
                MessageBox(response?.message ?? "error getting attesation", Constants.ERROR);
            }
        } catch (error) {
            MessageBox(error, Constants.ERROR);
        } finally {
            this.setState({ isShowAttestationLoader: false });
        }
    }

    emptyAttestationData() {
        return {
            isShowAttestationLoader: false,
            isRejectedAttestation: false,
            isShowDeleteAttestModal: false,
            isShowBackAttestationModal: false,
            isShowSwitchingAttestModal: false,
            isShowAttestationErrorModal: false,
            isAttestationSaveBtnDisabled: false,
            isAttestationDeleteBtnDisabled: false,
            attestationDetails: EmptyAttestDetails(),
            initialAttestationDetails: EmptyAttestDetails(),
            attestTimeCardDetails: {},
        }
    }

    async handleSuperVisorChange() {
        this.setState({ isShowAttestationLoader: true, isShowSwitchingAttestModal: false });
        try {
            let { attestationDetails, attestTimeCardDetails } = this.state;
            const emptyValue = "";
            const combinations = {
                [emptyValue]: Constants.ATTESTATION_YES,
                [Constants.ATTESTATION_YES]: emptyValue,
            };
            this.clearSignature2();
            await this.onDeleteAttestation(true);
            const prevSuperVisorOverride = attestationDetails.supervisorOverride;
            attestationDetails = { ...EmptyAttestDetails(), ...attestTimeCardDetails };
            attestationDetails.supervisorOverride = combinations[prevSuperVisorOverride];
            const initialAttestationDetails = cloneDeep(attestationDetails);
            if (prevSuperVisorOverride === emptyValue) {
                initialAttestationDetails.supervisorOverride = prevSuperVisorOverride;
            }
            this.setState({ attestationDetails, initialAttestationDetails });
        } catch (err) {
            MessageBox(err, Constants.ERROR);
        } finally {
            this.setState({ isShowAttestationLoader: false });
        }
    }

    clearSignature2() {
        if (this.state.signatureRef.current) {
            this.state.signatureRef.current.clear();
        }
    }

    async handleAttestationEditChange() {
        this.setState({ isShowAttestationLoader: true, isShowEditAttestationConfirmationModal: false });
        try {
            let { attestationDetails, attestTimeCardDetails, modifiedAttestationDetail } = this.state;
            await this.onDeleteAttestation(true);
            const emptyAttestationDetails = { ...EmptyAttestDetails(), ...attestTimeCardDetails };
            attestationDetails = { ...modifiedAttestationDetail };
            this.clearSignature2();
            if (this.state.popupRef.current) {
                this.state.popupRef.current.focus();
                this.state.popupRef.current.blur();
            }
            this.setState({ attestationDetails, initialAttestationDetails: cloneDeep(emptyAttestationDetails) });
        } catch (err) {
            MessageBox(err, Constants.ERROR);
        } finally {
            this.setState({ isShowAttestationLoader: false });
        }
    }

    handleAttestationChange(data, inputName, isYesBtn = false) {
        let { attestationDetails: currentAttestDetails, isShowSwitchingAttestModal, isShowEditAttestationConfirmationModal, attestTimeCardDetails, modifiedAttestationDetail } = this.state;
        const attestationDetails = { ...currentAttestDetails };
        const emptyValue = "";
        const checkYesOrNo = (a) => isYesBtn ? (a === Constants.ATTESTATION_YES ? emptyValue : Constants.ATTESTATION_YES) : ((a === Constants.ATTESTATION_NO ? emptyValue : Constants.ATTESTATION_NO));
        const checkYOrN = (a) => a ? Constants.ATTESTATION_YES : Constants.ATTESTATION_NO;
        const editableFields = [
            Constants.LANGUAGE_SELECTED,
            Constants.OVERRIDE_REASON,
            Constants.ATTESTATION_OTHER_REASON,
            Constants.APPROVED_ATTESTATION,
            Constants.REJECTION_A,
            Constants.REJECTION_B,
            Constants.REJECTION_C
        ];
        if (editableFields.includes(inputName) && currentAttestDetails.attestationStatus) {
            modifiedAttestationDetail = { ...EmptyAttestDetails(), ...attestTimeCardDetails };
            isShowEditAttestationConfirmationModal = true;

            switch (inputName) {
                case Constants.LANGUAGE_SELECTED:
                    modifiedAttestationDetail.languageSelected = data;
                    break;
                case Constants.APPROVED_ATTESTATION:
                    modifiedAttestationDetail.approvedAttestation = checkYOrN(isYesBtn);
                    modifiedAttestationDetail.languageSelected = attestationDetails.languageSelected;
                    break;
                case Constants.REJECTION_A: case Constants.REJECTION_B: case Constants.REJECTION_C:
                    modifiedAttestationDetail.approvedAttestation = Constants.ATTESTATION_NO;
                    modifiedAttestationDetail.languageSelected = attestationDetails.languageSelected;
                    modifiedAttestationDetail.rejectionA = inputName === Constants.REJECTION_A ? checkYOrN(data) : attestationDetails.rejectionA;
                    modifiedAttestationDetail.rejectionB = inputName === Constants.REJECTION_B ? checkYOrN(data) : attestationDetails.rejectionB;
                    modifiedAttestationDetail.rejectionC = inputName === Constants.REJECTION_C ? checkYOrN(data) : attestationDetails.rejectionC;
                    break;
                case Constants.OVERRIDE_REASON:
                    modifiedAttestationDetail.supervisorOverride = attestationDetails.supervisorOverride;
                    modifiedAttestationDetail.overrideReason = data;
                    modifiedAttestationDetail.otherReason = "";
                    break;
                case Constants.ATTESTATION_OTHER_REASON:
                    modifiedAttestationDetail.supervisorOverride = attestationDetails.supervisorOverride;
                    modifiedAttestationDetail.overrideReason = attestationDetails.overrideReason;
                    modifiedAttestationDetail.otherReason = data;
                    break;
            }
        } else {
            switch (inputName) {
                case Constants.LANGUAGE_SELECTED:
                    attestationDetails.languageSelected = data;
                    break;
                case Constants.OVERRIDE_REASON:
                    attestationDetails.overrideReason = data;
                    attestationDetails.otherReason = "";
                    break;
                case Constants.ATTESTATION_OTHER_REASON:
                    attestationDetails.otherReason = data;
                    break;
                case Constants.APPROVED_ATTESTATION:
                    attestationDetails.approvedAttestation = checkYesOrNo(attestationDetails.approvedAttestation);
                    attestationDetails.rejectionA = "";
                    attestationDetails.rejectionB = "";
                    attestationDetails.rejectionC = "";
                    break;
                case Constants.REJECTION_A:
                    attestationDetails.rejectionA = checkYesOrNo(attestationDetails.rejectionA);
                    break;
                case Constants.REJECTION_B:
                    attestationDetails.rejectionB = checkYesOrNo(attestationDetails.rejectionB);
                    break;
                case Constants.REJECTION_C:
                    attestationDetails.rejectionC = checkYesOrNo(attestationDetails.rejectionC);
                    break;
                case Constants.SUPERVISOR_OVERRIDE:
                    const supervisorOverrideValue = checkYesOrNo(attestationDetails.supervisorOverride);
                    if (
                        currentAttestDetails.approvedAttestation ||
                        currentAttestDetails.attestationStatus ||
                        currentAttestDetails.overrideReason ||
                        this.isSignatureExist()
                    ) {
                        isShowSwitchingAttestModal = true;
                    } else {
                        attestationDetails.supervisorOverride = supervisorOverrideValue;
                    }
                    break;
                case Constants.DRAWING_SIGNATURE:
                    attestationDetails.isSignatureExist = true;
                    break;
                default:
                    break;
            }
        }
        const attestationSwitchingMessage = data ? Constants.ATTESTATION_SUPERVISOR_SWITCHING_MESSAGE : Constants.ATTESTATION_EMPLOYEE_SWITCHING_MESSAGE;
        this.setState({ attestationDetails, isShowSwitchingAttestModal, attestationSwitchingMessage, isShowEditAttestationConfirmationModal, modifiedAttestationDetail });
    }

    formatAttestation(attestationDetails, isDelete = false) {
        const emptyValue = "";
        const employeeValue = (a) => isDelete ? emptyValue : (attestationDetails.supervisorOverride ? "" : a);
        const supervisorValue = (a) => isDelete ? emptyValue : (attestationDetails.supervisorOverride ? a : "");
        const overrideReason = (attestationDetails.supervisorOverride ? (attestationDetails.overrideReason === Constants.OTHER ? attestationDetails.otherReason : attestationDetails.overrideReason) : "");

        return {
            approvedAttestation: employeeValue(attestationDetails.approvedAttestation),
            rejectionA: employeeValue(attestationDetails.rejectionA),
            rejectionB: employeeValue(attestationDetails.rejectionB),
            rejectionC: employeeValue(attestationDetails.rejectionC),
            supervisorOverride: supervisorValue(attestationDetails.supervisorOverride),
            overrideReason: supervisorValue(overrideReason),
            languageSelected: isDelete ? emptyValue : attestationDetails.languageSelected,
            attestationStatus: isDelete ? emptyValue :
                (attestationDetails.supervisorOverride === Constants.ATTESTATION_YES ? (Constants.ATTESTATION_STATUS_OVERRIDE) :
                    (attestationDetails.approvedAttestation === Constants.ATTESTATION_YES ? Constants.ATTESTATION_STATUS_APPROVED : Constants.ATTESTATION_STATUS_REJECTED))
        }
    }

    async onDeleteAttestation(isSwitching = false) {
        this.setState({ isShowAttestationLoader: true, isAttestationDeleteBtnDisabled: true, isShowDeleteAttestModal: false });
        try {
            const { attestationDetails } = this.state;
            const attestTimeCardIds = attestationDetails.attestTimeCardIds;
            if (attestationDetails.attestationStatus && attestTimeCardIds.length > 0) {
                const attestationData = this.formatAttestation(attestationDetails, true);
                const requestData = {
                    ...attestationData,
                    deviceId: this.props.device.deviceId,
                    attestTimeCardIds: attestTimeCardIds,
                    isDelete: true
                };
                const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.CRTE_OR_UPDE_ATTST}`;
                const response = await Api.Post(url, requestData, this);
                if (response.success) {
                    if (!isSwitching) {
                        MessageBox(Constants.DELETED_SUCCESSFULLY, Constants.SUCCESS);
                    }
                } else {
                    MessageBox(response.message, Constants.ERROR);
                }
                if (!isSwitching) {
                    this.navigateToTimeCardPage();
                }
            }
        } finally {
            this.setState({ isShowAttestationLoader: false, isAttestationDeleteBtnDisabled: false });
        }
    }

    validateAttestation() {
        const { attestationDetails } = this.state;
        const totalHours = Number(attestationDetails.stHours) + Number(attestationDetails.otHours) + Number(attestationDetails.dtHours);
        const allPunches = [attestationDetails.startTime, attestationDetails.endTime, attestationDetails.lunchStartTime, attestationDetails.lunchEndTime]
        const responses = [attestationDetails.rejectionA, attestationDetails.rejectionB, attestationDetails.rejectionC];

        if (allPunches.some(a => !a)) {
            MessageBox(Constants.REQUIRE_ALL_PUNCHES, Constants.ERROR);
            return;
        }

        if (totalHours > 0) {
            if (CheckEnterHours(totalHours) && allPunches.some(a => a === Constants.NOT_APPLICABLE)) {
                MessageBox(Constants.REQUIRE_ALL_PUNCHES, Constants.ERROR);
                return;
            }

            if (attestationDetails.startTime === Constants.NOT_APPLICABLE || attestationDetails.endTime === Constants.NOT_APPLICABLE) {
                MessageBox(Constants.ENTER_START_TIME_AND_END_TIME, Constants.ERROR);
                return;
            }
            if (attestationDetails.stHours > 10) {
                MessageBox(Constants.ST_HOURS_CANNOT_BE_GREATER, Constants.ERROR);
                return;
            }
        }
        if (!attestationDetails.supervisorOverride && !attestationDetails.approvedAttestation) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.PLEASE_SELECT_ATLEAST_ONE_REJECTION });
            return;
        }
        if (!attestationDetails.supervisorOverride && attestationDetails.approvedAttestation === Constants.ATTESTATION_NO && !responses.some(a => a === Constants.ATTESTATION_YES)) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.PLEASE_SELECT_REJECT_REASON });
            return;
        } else if ((attestationDetails.supervisorOverride && !attestationDetails.overrideReason) || (attestationDetails.overrideReason === Constants.OTHER && !attestationDetails.otherReason)) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.PLEASE_ENTER_OVERRIDE_REASON });
            return;
        }
        if (!attestationDetails.isSignatureExist) {
            this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.PLEASE_ENTER_SIGNATURE, isShowAttestationLoader: false, isAttestationSaveBtnDisabled: false });
            return;
        }
        return true;
    }

    async saveAttestation() {
        this.setState({ isShowBackAttestationModal: false, isShowAttestationLoader: true, isAttestationSaveBtnDisabled: true });
        try {
            if (this.isAttestationFormChanged()) {
                const { attestationDetails, signatureRef } = this.state;
                const attestTimeCardIds = attestationDetails.attestTimeCardIds;
                if (!this.validateAttestation()) {
                    this.setState({ isShowAttestationLoader: false, isAttestationSaveBtnDisabled: false });
                    return;
                }
                if (this.isSignatureEmpty() || !this.isSignatureExist()) {
                    this.setState({ isShowAttestationErrorModal: true, attestErrorValidationMessage: Constants.PLEASE_ENTER_SIGNATURE, isShowAttestationLoader: false, isAttestationSaveBtnDisabled: false });
                    return;
                }
                const attestationData = this.formatAttestation(attestationDetails);
                const isSupervisor = attestationData.attestationStatus === Constants.ATTESTATION_STATUS_OVERRIDE;
                let attachmentContent = signatureRef.current?.toDataURL('image/png');
                attachmentContent = attachmentContent.split(',')[1];
                const attachmentName = isSupervisor ? Constants.ATTACHMENT_FOREMAN_ATTESTATION_TYPE : Constants.ATTACHMENT_EMPLOYEE_ATTESTATION_TYPE;
                const requestData = {
                    ...attestationData,
                    deviceId: this.props.device.deviceId,
                    attestTimeCardIds: attestTimeCardIds,
                    attachmentContent,
                    attachmentName,
                    stHours: `${attestationDetails.stHours}`,
                    otHours: `${attestationDetails.otHours}`,
                    dtHours: `${attestationDetails.dtHours}`,
                    employeeName: attestationDetails.employeeName,
                    employeeNumber: attestationDetails.employeeNumber,
                    startTime: attestationDetails.startTime,
                    endTime: attestationDetails.endTime,
                    lunchStartTime: attestationDetails.lunchStartTime,
                    lunchEndTime: attestationDetails.lunchEndTime,
                    createdDate: attestationDetails.createdDate
                };
                const url = `${ApiUrls.Routes.TME_CRD_C}${ApiUrls.Routes.CRTE_OR_UPDE_ATTST}`;
                const response = await Api.Post(url, requestData, this);
                if (response.success) {
                    MessageBox(Constants.ATTESTATION_SAVED_SUCCESSFULLY, Constants.SUCCESS);
                } else {
                    MessageBox(response.message, Constants.ERROR);
                }
            }
            this.navigateToTimeCardPage();
        } catch (err) {
            MessageBox(err, Constants.ERROR, Constants.ERROR);
        } finally {
            this.setState({ isShowAttestationLoader: false, isAttestationSaveBtnDisabled: false });
        }
    }

    clearSignature() {
        let { attestationDetails, isShowEditAttestationConfirmationModal, modifiedAttestationDetail } = this.state;
        if (attestationDetails.attestationStatus) {
            isShowEditAttestationConfirmationModal = true;
            modifiedAttestationDetail = {
                ...attestationDetails, attestationStatus: '', attachmentContent: '',
                isSignatureExist: false
            };
        } else {
            this.clearSignature2();
            attestationDetails.attachmentContent = "";
            attestationDetails.isSignatureExist = false;
        }
        this.setState({ attestationDetails, modifiedAttestationDetail, isShowEditAttestationConfirmationModal });
    }

    openOrCloseAttestationModals(modalName) {
        switch (modalName) {
            case Constants.ATTESTATION_ERROR_MODAL:
                this.setState({ isShowAttestationErrorModal: false, attestErrorValidationMessage: "", isShowBackAttestationModal: false, isAttestationSaveBtnDisabled: false });
                break;
            case Constants.ATTESTATION_SWITCHING_MODAL:
                this.setState({ isShowSwitchingAttestModal: false });
                break;
            case Constants.ATTESTATION_OPEN_DELETE_MODAL:
                this.setState({ isShowDeleteAttestModal: true });
                break;
            case Constants.ATTESTATION_CLOSE_DELETE_MODAL:
                this.setState({ isShowDeleteAttestModal: false });
                break;
            case Constants.ATTESTATION_CLOSE_BACK_MODAL:
                this.navigateToTimeCardPage();
                break;
            case Constants.ATTESTATION_EDIT_CONFIRMATION_MODAL:
                this.setState({ isShowEditAttestationConfirmationModal: false });
                break;
            default:
                break;
        }
    }

    isSignatureExist() {
        const { signatureRef } = this.state;
        const pointData = signatureRef.current?.toData();
        if (pointData.length > 0) {
            return true;
        }
        return false;
    }

    isSignatureEmpty() {
        const { signatureRef } = this.state;
        if (signatureRef.current?.isEmpty()) {
            return true;
        }
        return false;
    }

    isAttestationFormChanged() {
        const { attestationDetails, initialAttestationDetails } = this.state;
        return (this.isSignatureExist() || !isEqual(attestationDetails, initialAttestationDetails));
    }

    openOrCloseAttestationBackModal(isOpen = false) {
        if (isOpen && this.isAttestationFormChanged()) {
            this.setState({ isShowBackAttestationModal: true });
            return
        }
        this.goBack();
    }

    goBack() {
        this.props.history.goBack();
    }

    navigateToTimeCardPage() {
        this.props.history.push("/Timecard");
    }

    render() {
        const {
            attestationLanguages, supervisorOverrideReasons, attestationDetails, isAttestationSaveBtnDisabled,
            isAttestationDeleteBtnDisabled, signatureRef, isShowDeleteAttestModal, isShowBackAttestationModal,
            isShowSwitchingAttestModal, isRejectedAttestation, attestationSwitchingMessage, isShowAttestationLoader,
            isShowAttestationErrorModal, attestErrorValidationMessage, isShowEditAttestationConfirmationModal,
            attestationEditConfirmationMessage, popupRef, attestationPDF, isSubmittedAttestation, isFromWeekTimeCard } = this.state;
        return (
            <AttestationComponent
                ref={signatureRef}
                {
                ...{
                    attestation: {
                        attestationLanguages,
                        supervisorOverrideReasons,
                        attestationDetails,
                        isAttestationSaveBtnDisabled,
                        isAttestationDeleteBtnDisabled,
                        isShowDeleteAttestModal,
                        isShowBackAttestationModal,
                        isShowSwitchingAttestModal,
                        isShowAttestationLoader,
                        isRejectedAttestation,
                        attestationSwitchingMessage,
                        isShowAttestationErrorModal,
                        attestErrorValidationMessage,
                        isShowEditAttestationConfirmationModal,
                        attestationEditConfirmationMessage,
                        popupRef,
                        attestationPDF,
                        isSubmittedAttestation,
                        isFromWeekTimeCard
                    }
                }
                }
                handleAttestationChange={this.handleAttestationChange.bind(this)}
                saveAttestation={this.saveAttestation.bind(this)}
                clearSignature={this.clearSignature.bind(this)}
                onDeleteAttestation={this.onDeleteAttestation.bind(this)}
                openOrCloseAttestationBackModal={this.openOrCloseAttestationBackModal.bind(this)}
                handleSuperVisorChange={this.handleSuperVisorChange.bind(this)}
                openOrCloseAttestationModals={this.openOrCloseAttestationModals.bind(this)}
                handleAttestationEditChange={this.handleAttestationEditChange.bind(this)}
                goBack={this.goBack.bind(this)}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, loginActions), dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Attestation));